import { render, staticRenderFns } from "./ClimateGis.vue?vue&type=template&id=6930bcd4&scoped=true"
import script from "./ClimateGis.vue?vue&type=script&lang=js"
export * from "./ClimateGis.vue?vue&type=script&lang=js"
import style0 from "./ClimateGis.vue?vue&type=style&index=0&id=6930bcd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6930bcd4",
  null
  
)

export default component.exports